import cn from 'classnames';

import LoaderIcon from '@src/assets/icons/LoaderIcon';

import './oLoader.scss';

interface IProps {
  theme?: 'white' | 'black';
  description?: string;
  absolute?: boolean;
}

const OLoader = ({ theme = 'black', absolute = true, description = "We're just making the magic happen!" }: IProps) => {
  return (
    <div className={cn('loader-container', theme, { 'absolute-container': absolute })}>
      <LoaderIcon />
      <div className="text-container">
        <div className="title">Loading...</div>
        {!!description?.trim().length && <div className="description">{description}</div>}
      </div>
    </div>
  );
};

export default OLoader;
